export default "__VITE_ASSET__MKgRviMP__"